export default __webpack_public_path__ + "assets/images/pay_second.2db038.webp";